export default "/images/9234a920825504e598e208fef153fbac.avif";